import CartAccountCreatePageV2 from './CartAccountCreatePageV2'

export default CartAccountCreatePageV2
// eslint-disable-next-line import/export
export * from './CartAccountCreatePageV2'
